var map = {
	"./image_Areca.jpg": 9819,
	"./image_Barringtoniaasiatica.jpg": 412,
	"./image_Chinaberry.jpg": 2434,
	"./image_LargeLeavedNanmu.jpg": 1066,
	"./image_Mango.jpg": 6819,
	"./image_PaperMulberry.jpg": 4481,
	"./image_Parasolleaftree.jpg": 2778,
	"./image_Soapberry.jpg": 5774,
	"./image_SpinyBamboo.jpg": 7772,
	"./image_TaiwanFlamegold.jpg": 6158,
	"./image_Taiwancrapemyrtle.jpg": 6773,
	"./image_VitexNigra.jpg": 3078
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1310;